// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aicard {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ededed;
  padding: 24px;
  box-sizing: border-box;
  margin-top: 16px;
}
.aicard__info {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 12px;
}
.aicard__link {
  color: #1e1c1a;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  margin: 0;
  padding-left: 8px;
}
.aicard__count {
  color: #b1b1b1;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  margin: 0;
}
.aicard__pdf {
  color: #1e1c1a;
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
  margin: 0;
  padding-left: 12px;
}
.aicard__text{
    color: #1E1C1A;
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: left;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Aicard/Aicard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;AACA;IACI,cAAc;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX","sourcesContent":[".aicard {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #ededed;\n  padding: 24px;\n  box-sizing: border-box;\n  margin-top: 16px;\n}\n.aicard__info {\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n  margin-bottom: 12px;\n}\n.aicard__link {\n  color: #1e1c1a;\n  font-family: Roboto;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 16px;\n  margin: 0;\n  padding-left: 8px;\n}\n.aicard__count {\n  color: #b1b1b1;\n  font-family: Roboto;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 16px;\n  margin: 0;\n}\n.aicard__pdf {\n  color: #1e1c1a;\n  font-family: Roboto;\n  font-size: 18px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 24px;\n  margin: 0;\n  padding-left: 12px;\n}\n.aicard__text{\n    color: #1E1C1A;\n  font-family: Roboto;\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: left;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
